var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form-checkbox',{attrs:{"checked":_vm.checked},on:{"change":_vm.handleChange}},[_vm._v(" 전체선택 ")])}
var staticRenderFns = []

export { render, staticRenderFns }